import React from 'react';
import './CheatSheet.css';

const CheatSheet = () => {
    return (
        <div className="section" id='sheet'>
            <div className="container">
                <div className='section-title text-center'>
                    <span className="text-color mb-0 text-uppercase letter-spacing text-sm"> <i className="ti-minus mr-2"></i>LEARNINGS</span>
                    <h1 className="title">CheatSheet</h1>
                </div>
            </div>
        </div>
    )
}

export default CheatSheet